module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"copied":"Copied!","sectionTitle":"Landing Page URL","copyLandingPageText":"Copy a link to your landing page or share it with your fans.","copyUrlButtonLabel":"Copy link","copyLinkErrorMessage":"The link could not be copied"}}')
  delete Component.options._Ctor
}
